import util from "./util";
import fetch from "isomorphic-fetch";
import "./cards/localUnion/planCodeSearch";

$(function () {
  $("#btnSendForgotPassword").on("click", function (e) {
    e.preventDefault();
    e.currentTarget.innerText = $("#hidButtonSendingText").val();
    e.currentTarget.disabled = "disabled";
    $("#verifyForgotPasswordUnsuccessful").addClass("hide").removeClass("show");
    fetch(util.getGqlUrl(), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(
        getForgotPasswordMutation(
          $("input[name='ForgotPasswordUsername']").val(),
          $("#forgotPasswordCaptchaKey").val(),
        ),
      ),
    })
      .then(function (res) {
        if (res.status !== 400 && res.status !== 200) {
          throw Error(res.status + " " + res.statusText);
        }
        return res.json();
      })
      .then(function (res) {
        if (
          typeof res.ErrorRef !== "undefined" &&
          res.ErrorRef !== null &&
          res.ErrorRef.length > 0
        ) {
          let errorMessage = "";
          if (
            typeof res.SystemMessages !== "undefined" &&
            res.SystemMessages !== null &&
            res.SystemMessages.length > 0 &&
            typeof res.SystemMessages[0].Message !== "undefined" &&
            res.SystemMessages[0].Message !== null &&
            res.SystemMessages[0].Message.length > 0
          ) {
            errorMessage = res.SystemMessages[0].Message + " ";
          }
          throw Error(errorMessage + res.ErrorRef);
        } else {
          if (res?.data?.user?.forgot_password?.forgot_password === "2") {
            // 2 means employee requested password reset so show employee message
            $("#verifyForgotPasswordSuccessfulEmployee")
              .addClass("show")
              .removeClass("hide");
          } else {
            $("#verifyForgotPasswordSuccessful")
              .addClass("show")
              .removeClass("hide");
          }
          $("#btnSendForgotPassword").addClass("hide");
          $("#forgotPasswordUsername").addClass("hide");
          $("#forgotPasswordCaptcha").addClass("hide");
        }
      })
      .catch(function (err) {
        $("#btnSendForgotPassword")
          .removeAttr("disabled")
          .text($("#hidButtonText").val());
        $("#verifyForgotPasswordUnsuccessful")
          .addClass("show")
          .removeClass("hide");
        let errorText = $("#hidErrorText").val();
        let errorElement = $("#sendForgotPasswordErrorMessage");
        errorElement.text(
          errorText.replace("[:ErrorReferenceCode:]", err.message),
        );
      });
  });

  $("input[name='ForgotPasswordUsername']").on("keyup", function () {
    checkForCompletion();
  });

  $(function () {
    const loginWrap = $(".loginBtnWrap.dropdownPanelWrap");
    $("body").on("click", function (e) {
      if (loginWrap.hasClass("show")) {
        e.stopPropagation();
      }
    });
  });

  $("button[name='btnLogin']").on("click", function (e) {
    e.preventDefault();
    const loginWrap = $(".loginBtnWrap.dropdownPanelWrap");
    const loginDropDown = $(".loginBtnWrap.dropdownPanelWrap > .dropdown-menu");
    if (!loginWrap.hasClass("show") && location.pathname !== "/login") {
      loginWrap.addClass("show");
      loginDropDown.addClass("show");
    }
    $("body").on("click", function (e) {
      if (loginWrap.hasClass("show")) {
        e.stopPropagation();
      }
    });
    let $form = $(e.target).closest("form");
    let inputsValid = true;
    let username = $($form).find("input[name='UserName']");
    if (!username.val()) {
      handleFieldError(username);
      inputsValid = false;
    }
    let password = $($form).find("input[name='Password']");
    if (!password.val()) {
      handleFieldError(password);
      inputsValid = false;
    }
    let stayLoggedIn = $($form).find("input[name='StayLoggedIn']");
    let token = $form.find("input[name='__RequestVerificationToken']").val();
    let $loginError = null;
    if (inputsValid) {
      $.ajax({
        url: "/api/account/login",
        type: "POST",
        contentType: "application/x-www-form-urlencoded; charset=utf-8",
        dataType: "JSON",
        data: {
          __RequestVerificationToken: token,
          username: username.val(),
          password: password.val(),
          stayLoggedIn: stayLoggedIn.prop("checked"),
          datasourceId: $form.attr("datasourceid"),
          returnUrl: util.getParameterByName("returnUrl"),
          redirect: true,
        },
        beforeSend: function () {
          $(e.target).closest("button").addClass("isLoading");
          $loginError = $($form).find("#loginError");
        },
        success: function (data) {
          if (data) {
            if (data.Success === false) {
              $(e.target).closest("button").removeClass("isLoading");
              handleError($loginError, $form, data.Message);
            } else {
              if (data.Data) {
                //received a redirect URL, let's use that.
                window.location.replace(data.Data);
              } else {
                //well, this isn't good. Something went wrong for sure...
                $(e.target).closest("button").removeClass("isLoading");
                handleError($loginError, $form);
              }
            }
          }
        },
        error: function (jqXHR) {
          if (jqXHR && jqXHR.status === 500) {
            //redirect to 500 page
            window.location.replace(window.location + "500");
          }
          $(e.target).closest("button").removeClass("isLoading");
          handleError($loginError, $form);
        },
      });
    }
  });

  $("#btnResendEmailVerification").on("click", function (e) {
    e.preventDefault();
    let token = $("#hidVerificationToken").val();
    let sendingButtonText = $("#hidResendLinkButtonSendingText").val();
    let csrfToken = $("input[name='__RequestVerificationToken']").val();
    let originalButtonText = null;
    let source = util.getParameterByName("source");
    let url = "/api/account/sendemailverificationemail";
    if (source && source.length > 0) {
      url += `/${source}`;
    }
    $.ajax({
      url,
      type: "POST",
      contentType: "application/x-www-form-urlencoded; charset=utf-8",
      dataType: "JSON",
      data: {
        __RequestVerificationToken: csrfToken,
        token: token,
      },
      beforeSend: function () {
        $(e.target).attr("disabled", "disabled");
        originalButtonText = e.target.innerText;
        e.target.innerText = sendingButtonText;
      },
      success: function (data) {
        if (data) {
          $("#verifyEmailResendSuccessful")
            .removeClass("hide")
            .addClass("show");
          $("#btnResendEmailVerification").hide();
        } else {
          $("#verifyEmailResendUnsuccessful")
            .removeClass("hide")
            .addClass("show");
        }
      },
      error: function () {
        $("#verifyEmailResendUnsuccessful")
          .removeClass("hide")
          .addClass("show");
      },
      complete: function () {
        $(e.target).removeAttr("disabled");
        e.target.innerText = originalButtonText;
      },
    });
  });

  $("input[name='UserName']").on("keyup", function (e) {
    if (e.which !== 13) {
      clearFieldError(e);
    }
  });

  $("input[name='Password']").on("keyup", function (e) {
    if (e.which !== 13) {
      clearFieldError(e);
    }
  });

  $("input[name='Password']").on("keydown", function (e) {
    let caps = e.getModifierState && e.getModifierState("CapsLock");
    if (caps) {
      window.capsLockEnabled = true;
      $(e.currentTarget)
        .parent()
        .find("#divCapsLockStatus")
        .removeClass("hide");
    } else {
      window.capsLockEnabled = false;
      $(e.currentTarget).parent().find("#divCapsLockStatus").addClass("hide");
    }
  });
});

window.forgotPasswordRecaptchaCallback =
  function forgotPasswordRecaptchaCallback(token) {
    $("#forgotPasswordCaptchaKey").val(token);
    checkForCompletion();
  };

window.forgotPasswordRecaptchaExpiredCallback =
  function forgotPasswordRecaptchaExpiredCallback() {
    $("#forgotPasswordCaptchaKey").val("");
    checkForCompletion();
  };

function getForgotPasswordMutation(username, token) {
  return {
    query:
      "mutation ($username: String!, $token: String!, $sitename: String!) { user { forgot_password (username: $username, token: $token, sitename: $sitename) { forgot_password } } }",
    variables: {
      token: token,
      username: username,
      sitename: "teamcare",
    },
  };
}

function checkForCompletion() {
  let captcha = $("#forgotPasswordCaptchaKey").val();
  let username = $("input[name='ForgotPasswordUsername']").val();
  if (username.length > 0 && captcha.length > 0) {
    $("#btnSendForgotPassword").removeAttr("disabled");
  } else {
    $("#btnSendForgotPassword").attr("disabled", "disabled");
  }
}

function clearError(element) {
  if (element) {
    let $form = element.closest("form");
    let $loginError = $($form).find("#loginError");
    if ($loginError.length > 0) {
      $($loginError).addClass("hide");
    }
  }
}

function handleError(sender, $form, message) {
  const clean = util.sanitizeHtml(message);
  if (sender) {
    $($form).find("label.field").addClass("error");
    $(sender).removeClass("hide");
    if (message) {
      $($form).find("label.field").addClass("error");
      $(sender).find(".fieldNote").html(clean);
      $(sender).removeClass("hide");
    }
  }
}

function handleFieldError(element) {
  let $thisField = element.closest(".field");
  $thisField.addClass("error");
  let $thisFieldNotes = $thisField.find(".fieldNotes");
  $thisFieldNotes.removeClass("hide");
}

function clearFieldError(e) {
  let element = $(e.target);
  let $thisField = element.closest(".field");
  $thisField.removeClass("error");
  let $thisFieldNotes = $thisField.find(".fieldNotes");
  $thisFieldNotes.addClass("hide");
  clearError(element);
}
